// useDebounce.js
import { useState, useEffect } from "react";

const useDebounce = (value, delay = 500, callback) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      if (callback) callback(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay, callback]);

  return debouncedValue;
};

export default useDebounce;